module.exports = __webpack_public_path__ + "static/media/ventajas-banner.d9101abe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ventajas/ventajas-banner.png
// module id = 172
// module chunks = 0